import { Button, Modal } from "../../components";
import useLanguage from "../../hooks/language";
import styles from "./appointment-hold-expired.module.css";

const preventModalDismiss = (): void => {
    return;
};

export default function AppointmentHoldExpiredModal({
    visible,
    onRestart,
}: {
    visible: boolean;
    onRestart: () => void;
}): React.ReactElement {
    const { translations } = useLanguage();
    const t = translations.appointmentHoldExpiredModal;

    return (
        <Modal
            showHeader={false}
            visible={visible}
            onRequestClose={preventModalDismiss}
            className={styles["appointment-hold-expired-modal"]}
        >
            <div className={styles["appointment-hold-expired-modal__content"]}>
                <div
                    className={
                        styles[
                            "appointment-hold-expired-modal__title-container"
                        ]
                    }
                >
                    <div
                        className={
                            styles["appointment-hold-expired-modal__emoji"]
                        }
                    >
                        ⏱️
                    </div>

                    <h3
                        className={
                            styles["appointment-hold-expired-modal__title"]
                        }
                    >
                        {t.title}
                    </h3>

                    <div
                        className={
                            styles[
                                "appointment-hold-expired-modal__description"
                            ]
                        }
                    >
                        {t.description}
                    </div>
                </div>

                <Button
                    type="primary"
                    className={styles["appointment-hold-expired-modal__cta"]}
                    onClick={onRestart}
                >
                    {t.cta}
                </Button>
            </div>
        </Modal>
    );
}
